import config from 'scoreboard/components/config'
import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'

/**
 * Returns a message to be displayed about a domain object based on whether it
 * is replicated (issue #8518)
 */
function replicatedMessage(model) {
	var replicated = null
	var attributes = model.attributes || model
	if (!_.isNil(attributes.syncId)) {
		if (config.replicationOutputEnabled) {
			replicated = i18n.get('common.replication.isReplicated.nipr')
		}
		if (config.replicationInputEnabled) {
			replicated = i18n.get('common.replication.isReplicated.sipr')
		}
	}
	return replicated
}

export default replicatedMessage

replicatedMessage.__filename__ = 'components/replicated-message.js'
